import React from 'react';
import './privacypolicies.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <h1 className="privacy-policy-title">Política de Privacidad</h1>
            <p className="privacy-policy-text">
                Esta política describe nuestras prácticas de privacidad, información personal que consultamos, cómo se le utiliza y comparte, además las opciones y derechos que usted tiene en relación con esta información. Se aplica a nuestros Servicios donde sea que los proporcionemos, y nos atenemos a las normas locales vigentes en relación con todas las prácticas descritas en esta política.
            </p>
            <p className="privacy-policy-text">
                Esta política alcanza todos los usuarios de Conexs, cualquiera de las aplicaciones móviles de Conexs (en adelante, las "Aplicaciones") sea para Usuario Conductor o Usuario Pasajero, y cualquier servicio que proporcionemos a través del Sitio web o de las Aplicaciones, así como cuando usted contacte con nosotros por teléfono, correo electrónico, redes sociales, en persona o cualquier otro medio (en adelante en conjunto, los "Servicios").
            </p>
            <p className="privacy-policy-text">
                Para su satisfacción y correcto funcionamiento de nuestros servicios, le comentamos que recopilamos y usamos la siguiente información:
            </p>
            <h2 className="privacy-policy-subtitle">Si es Usuario Pasajero:</h2>
            <ul className="privacy-policy-list">
                <li>Información para el registro y perfil: nombre, teléfono, email, número de DNI.</li>
            </ul>
            <h2 className="privacy-policy-subtitle">Si es Usuario Conductor:</h2>
            <ul className="privacy-policy-list">
                <li>Licencia de conducir, tarjeta de propiedad, SOAT, información del vehículo (tipo, marca, modelo, año de fabricación, color).</li>
                <li>Datos del permiso de circulación, matrícula, informe de inspección del vehículo, foto del vehículo.</li>
                <li>Datos del documento de identidad, certificado de residencia, dirección física, fecha de nacimiento, número de identificación de contribuyente.</li>
                <li>Historial de conducción y otros documentos requeridos por normativa aplicable.</li>
                <li>Verificación de identidad y comprobación de antecedentes cuando la ley lo permita.</li>
            </ul>
            <h2 className="privacy-policy-subtitle">Información que recopilamos automáticamente:</h2>
            <h3 className="privacy-policy-subheading">Información sobre la ubicación:</h3>
            <p className="privacy-policy-text">
                Recopilamos los datos sobre la ubicación de los Usuarios para permitir los viajes, asistencia al cliente, seguridad, detección de fraudes y para satisfacer requerimientos legales. Esto incluye coordenadas GPS y datos WiFi según la configuración de su Aplicación y permisos del dispositivo.
            </p>
            <h3 className="privacy-policy-subheading">Información sobre la transacción:</h3>
            <p className="privacy-policy-text">
                Incluye detalles como tipo de servicios solicitados o prestados, información de pagos, rutas y métodos de pago.
            </p>
            <h3 className="privacy-policy-subheading">Información de uso:</h3>
            <p className="privacy-policy-text">
                Datos sobre cómo utiliza nuestros Servicios, visitas a páginas, y actividades del sistema.
            </p>
            <h3 className="privacy-policy-subheading">Información sobre las comunicaciones:</h3>
            <p className="privacy-policy-text">
                Incluye datos como mensajes enviados entre Usuarios o a nosotros, y grabaciones de llamadas telefónicas.
            </p>
            <h3 className="privacy-policy-subheading">Información sobre el dispositivo:</h3>
            <p className="privacy-policy-text">
                Recogemos datos sobre el dispositivo que utiliza, como el nombre, modelo, dirección IP, sistema operativo, y más.
            </p>
            <h3 className="privacy-policy-subheading">Cómo almacenamos su información:</h3>
            <p className="privacy-policy-text">
                Conservamos su información mientras sea necesaria para prestarle nuestros Servicios, cumplir con obligaciones legales, y otros fines descritos en esta política.
            </p>
            <p className="privacy-policy-text">
                Al utilizar Conexs, usted acepta los términos más actuales de esta política.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
